import { useEffect, useState } from "react";
import { ChallengeScheme, Track } from "client-v2";
import { useNavigate } from "react-router";
import dayjs from "dayjs";

import Header from "../../components/section/Header";
import Info from "./section/Info";
import Resume from "../../components/section/ResumeDetail";
import Container from "../../components/container/Container";
import { ColorV2 } from "@adoptaunabuelo/react-components";
import { useDispatch, useSelector } from "react-redux";
import { actionsCreators, State } from "../../redux";
import { bindActionCreators } from "redux";
import CrossSell from "../../components/section/CrossSell";
import CurrencySelector from "../../components/selector/CurrencySelector";

const Detail = (props: Props) => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { setShowSuccess } = bindActionCreators(actionsCreators, dispatch);
	const currentUser = useSelector((state: State) => state.user.currentUser);
	const loading = useSelector((state: State) => state.modals.loading);

	const [pastDate, setPastDate] = useState(false);
	const [completed, setCompleted] = useState(false);

	useEffect(() => {
		//Track to Mixpanel
		Track.event({
			event: "challenge view init",
			user: currentUser,
			params: {
				challengeId: props.challenge.objectId,
				view: "challenge",
			},
		});

		//Check if past date
		const diff = dayjs(props.challenge.endDate.iso).diff(dayjs(), "days");
		if (diff <= 0) setPastDate(true);

		//Check if goal completed
		const restAmount = props.challenge.goal - props.challenge.amount;
		if (restAmount <= 0) setCompleted(true);
	}, []);

	const onNextClick = () => {
		if (pastDate || completed) {
			navigate("/donacion");
		} else {
			navigate("/reto/registro/?id=" + props.challenge.objectId, {
				state: {
					challenge: props.challenge,
				},
			});
		}
	};

	const onShareClick = (op: any) => {
		const url =
			"https://adoptaunabuelo.org/reto/?id=" + props.challenge.objectId;
		if (op.id === "twitter") {
			window.open("http://www.twitter.com/share?url=" + url, "_blank");
		} else if (op.id === "facebook") {
			window.open("http://www.facebook.com/sharer.php?u=" + url);
		} else if (op.id === "whatsapp") {
			window.open("whatsapp://send?text=" + url);
		} else if (op.id === "url") {
			navigator.clipboard.writeText(url);
			setShowSuccess({
				show: true,
				message: "Se ha copiado el enlace en tu portapapeles",
			});
		}
	};

	return (
		<>
			<Container
				loading={loading}
				style={{ backgroundColor: "white" }}
				headerProps={{
					childrenPosition: "right",
					children: <CurrencySelector />,
				}}
				footerProps={{
					style: { backgroundColor: "white" },
					buttonProps: {
						style: {
							width: "100%",
							backgroundColor:
								props.challenge.type === "rose" &&
								ColorV2.surface.redMedium,
						},
						children:
							props.challenge.type === "signature"
								? "Quiero firmar"
								: props.challenge.type === "rose"
								? "Quiero regalar una rosa"
								: "Quiero colaborar",
						onClick: onNextClick,
					},
				}}
				RightView={
					<Resume
						challenge={props.challenge}
						supporters={props.supporters}
						onClick={onNextClick}
						onShareClick={onShareClick}
					/>
				}
			>
				<Header challenge={props.challenge} />
				<Info
					challenge={props.challenge}
					supporters={props.supporters}
				/>
			</Container>
			<CrossSell />
		</>
	);
};
export default Detail;
export interface Props {
	challenge: ChallengeScheme;
	supporters: Array<any>;
}
